import React, { useState } from "react";
import { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { IoAddCircleOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import EditButton from "../../components/EditButton";
import DeleteButton from "../../components/DeleteButton";
import FillingDataTable from "../../components/FillingDataTable";
import Pagination from "../../components/Pagination";
import Select from "../../components/Select";
import { createItem, deleteItem } from "../../services/service";
import swal from "sweetalert";
import ModalAccessoriesDependLimit from "../../components/accessories/ModalAccessoriesDependLimit";
import { toast } from "react-toastify";
import TableComponent from "../../components/tableComponent/tableComponent";

const headerTable = [
  { name: "number" },
  { name: "minLength" },
  { name: "maxLength" },
  { name: "minCorner" },
  { name: "maxCorner" },
  { name: "actions" },
];
const bodyContent = [
  "number",
  "minLength",
  "maxLength",
  "minCorner",
  "maxCorner",
  "actions",
];

function AccessoriesDependLimitLayout({ selectedDependSideLimitId, t }) {
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.user);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [itemOffset, setItemOffset] = useState(0);
  const [forcePage, setForcePage] = useState(0);
  const [data, setData] = useState({
    data: [],
    recordsTotal: 0,
    pageCount: 1,
  });
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [rowId, setRowId] = useState(null);

  const handleClose = () => {
    setOpen(false);
    setRowId(null);
    setIsEdit(false);
  };
  const handleOpen = () => {
    setOpen(true);
    setRowId(null);
    setIsEdit(false);
  };
  const fetchData = async () => {
    const response = await createItem(
      `${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories/specification/limit/side/table`,
      token,
      {
        draw: 1,
        start: itemOffset,
        length: itemsPerPage,
        recordsTotal: 0,
        columns: [],
        order: [],
        search: { value: "", regex: true },
        filter: { dependSpecificationId: selectedDependSideLimitId },
      }
    );
    if (response.success) {
      let reviewData = response.data.data.map((item, index) => {
        return {
          ...item,
          actions: (
            <div className="flex justify-end mt-3 sm:mt-0 sm:ml-4">
              <EditButton onclick={() => editHandler(item.id)} />
              <DeleteButton onclick={() => deleteHandler(item.id)} />
            </div>
          ),
        };
      });
      setData({
        data: reviewData,
        recordsTotal: response.data.recordsFiltered,
        pageCount: Math.ceil(
          response.data.recordsFiltered / parseInt(itemsPerPage)
        ),
      });
    } else {
      navigate("/error", {
        state: {
          status: response.status,
          message: response.message ? response.message : null,
        },
      });
    }
  };

  useEffect(() => {
    if (selectedDependSideLimitId) {
      fetchData();
    } else {
      setData({ data: [], recordsTotal: 0, pageCount: 1 });
    }
  }, [selectedDependSideLimitId, itemOffset, itemsPerPage, data.recordsTotal]);

  const handlePageClick = (event) => {
    setForcePage(event.selected);
    const newOffset =
      (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
    setItemOffset(newOffset);
  };

  const deleteHandler = async (id) => {
    const responseReceived = await swal({
      title: t(`action.delete_item.title`),
      text: t(`action.delete_item.text`),
      icon: "warning",
      buttons: {
        cancel: true,
        confirm: true,
      },
    });
    if (responseReceived) {
      const response = await deleteItem(
        `${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories/specification/limit/side/${id}`,
        token
      );
      if (response.success) {
        fetchData();
        toast.success(t("action.delete_success"), {
          position: "bottom-right",
          autoClose: 3000,
          closeOnClick: true,
          className: "add-success",
        });
      } else {
        navigate("/error", {
          state: {
            status: response.status,
            message: response.message ? response.message : null,
          },
        });
      }
    } else {
      return;
    }
  };
  const editHandler = (id) => {
    setIsEdit(true);
    setRowId(id);
    setOpen(true);
  };
  return (
    <>
      <ModalAccessoriesDependLimit
        open={open}
        isEdit={isEdit}
        rowId={rowId}
        handleClose={handleClose}
        dependSpecificationId={selectedDependSideLimitId}
        fetchData={fetchData}
      />
      <div className="sm:flex-auto">
        <h1 className="text-xl font-semibold text-gray-900">
          {t(`table.accessories.accessories_dependent_limit`)}
        </h1>
      </div>
      <div className="flex items-center justify-between">
        <Select setItemsPerPage={setItemsPerPage} itemsPerPage={itemsPerPage} />
        <button
          className={`${
            selectedDependSideLimitId
              ? "flex items-center px-3 py-1 text-sm font-medium leading-4 text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              : "cursor-no-drop flex items-center px-3 py-1 text-sm font-medium leading-4 text-white bg-indigo-300 border border-transparent rounded-md shadow-sm "
          }   `}
          onClick={handleOpen}
          disabled={selectedDependSideLimitId ? false : true}
        >
          {t("action.add")}
          <IoAddCircleOutline className="w-4 h-4 ml-1" />
        </button>
      </div>
      <TableComponent
        transactions={data.data}
        bodyOfTable={bodyContent}
        headerOfTable={headerTable}
        rowHandler={(id) => {
          const updatedData = data.data.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                selected: true,
              };
            } else {
              return {
                ...item,
                selected: false,
              };
            }
          });
          setData((prevState) => {
            return {
              ...prevState,
              data: updatedData,
            };
          });
        }}
      />
      <Pagination
        handlePageClick={handlePageClick}
        pageCount={data.pageCount}
        forcePage={forcePage}
      />
    </>
  );
}

export default withTranslation()(AccessoriesDependLimitLayout);
